import camelize from 'camelcase-keys-deep';

export default class ProcessCategories {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
